import AlarmOffOutlinedIcon from '@mui/icons-material/AlarmOffOutlined';
import AlarmOutlinedIcon from '@mui/icons-material/AlarmOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LocalPostOfficeOutlinedIcon from '@mui/icons-material/LocalPostOfficeOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { Grid, Stack, Typography } from '@mui/material';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import YesNoDialog from 'common/components/YesNoDialog';
import useFlexBoxStyles from 'common/flexBox';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { deleteReminderAction } from 'redux/slices/iCalendarV4/reminderSlice';
const ICalendarReminderRow = ({ reminder, handleEdit }) => {
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const dispatch = useDispatch();
    const [openConfirmDeleteDlg, setOpenConfirmDeleteDlg] = useState(false);
    const handleDelete = () => {
        setOpenConfirmDeleteDlg(true);
    };

    const confirmDlg = () => {
        dispatch(deleteReminderAction({ id: reminder.id }));
        setOpenConfirmDeleteDlg(false);
    };

    const cancelDlg = () => {
        setOpenConfirmDeleteDlg(false);
    };

    const actions = (
        <Stack direction="row" spacing={1}>
            <CustomTooltip arrow placement="bottom" title={t('actions.edit')} aria-label="edit installation">
                <CustomIconButton id="onlive-button-edit" size="small" onClick={handleEdit} hideBorder={true}>
                    <EditOutlinedIcon component="svg" />
                </CustomIconButton>
            </CustomTooltip>

            <CustomTooltip arrow placement={'bottom'} title={t('actions.delete')} aria-label="delete installation">
                <CustomIconButton id="onlive-button-delete" size="small" onClick={handleDelete} hideBorder={true}>
                    <DeleteOutlinedIcon component="svg" />
                </CustomIconButton>
            </CustomTooltip>
        </Stack>
    );

    const time = reminder.direction === 'before' ? t('iCalendar.reminder.before') : t('iCalendar.reminder.after');
    <Grid container spacing={0}>
        <Grid item md={2}>
            <Typography variant="onliveH6" fontWeight={500}>
                {t('app.common.status')}
            </Typography>
        </Grid>
        <Grid item md={4}>
            <Typography variant="onliveH6" fontWeight={500}>
                {t('game.gameItem.time')}
            </Typography>
        </Grid>
        <Grid item md={2}>
            <Typography variant="onliveH6" fontWeight={500}>
                {t('iCalendar.reminder.delivery')}
            </Typography>
        </Grid>
        <Grid item md={2}>
            <Typography variant="onliveH6" fontWeight={500}>
                {t('app.common.type')}
            </Typography>
        </Grid>
        <Grid item md={2}></Grid>
    </Grid>;
    return (
        <>
            <Grid container spacing={0} key={reminder.id}>
                <Grid item md={2} className={flexBox.flex}>
                    <CustomTooltip
                        arrow
                        placement={'right'}
                        title={reminder.enabled ? t('app.common.enabled') : t('app.common.disabled')}
                    >
                        {reminder.enabled ? (
                            <AlarmOutlinedIcon color={'success'} />
                        ) : (
                            <AlarmOffOutlinedIcon color={'disabled'} />
                        )}
                    </CustomTooltip>
                </Grid>
                <Grid item md={3}>
                    <Typography variant="onliveH6" fontWeight={500}>
                        {`${reminder.time}${reminder.unit} ${time}`}
                    </Typography>
                </Grid>
                <Grid item md={3} className={flexBox.flex}>
                    <CustomTooltip
                        arrow
                        placement="right"
                        title={
                            reminder.deliveryMethod === 'async_message'
                                ? t('iCalendar.reminder.deliveryMethod.asyncMessage')
                                : t('iCalendar.reminder.deliveryMethod.realtimeSocket')
                        }
                    >
                        {reminder.deliveryMethod === 'async_message' ? (
                            <LocalPostOfficeOutlinedIcon component="svg" />
                        ) : (
                            <NotificationsNoneOutlinedIcon component="svg" />
                        )}
                    </CustomTooltip>
                </Grid>
                <Grid item md={2}>
                    <Typography variant="onliveH6" fontWeight={500}>
                        {t(`reminder.targetActorTypes.${reminder.targetActorType}`)}
                    </Typography>
                </Grid>
                <Grid item md={2} className={cx(flexBox.flex, flexBox.justifyContentEnd)}>
                    {actions}
                </Grid>
            </Grid>
            {openConfirmDeleteDlg && (
                <YesNoDialog
                    openDialog={true}
                    title={t('reminder.action.deleteConfirm')}
                    messageToConfirm={t('reminder.action.deleteMessage')}
                    yesButtonCallback={confirmDlg}
                    noButtonCallback={cancelDlg}
                />
            )}
        </>
    );
};

export default ICalendarReminderRow;
